<template>
  <div>
    <!-- Loading Overlay -->
    <div v-if="saving" class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style="background-color: rgba(0,0,0,0.5); z-index: 9999;">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    
    <div class="px-3">
      <button v-if="ismodal != 'true' && istree != 'true'" class="btn btn-outline-primary me-4" @click.prevent="current_id=0">&lt; Return to list</button>
      <button v-if="ismodal == 'true'" class="btn btn-outline-primary me-4" @click.prevent="record_cancel">Close</button>
      <button class="btn btn-primary float-end" @click.prevent="record_save">
        <fa-icon name="check" />
        Save
      </button>
      <button v-if="standalone != 'true' && istree != 'true'" class="btn btn-secondary float-end me-4" @click.prevent="record_savereturn">
        <fa-icon name="check" />
        Save and return to list
      </button> 
    </div>

    <div
      class="col-12 float-start"
      v-if="tablename=='g_elearning_modules'"
    >
      <div class="mb-3">
        <label class="form-label">
          If this module is an exam, select the exam from the list below
        </label>
        <select
          class="form-select"
          v-model="control_exam_id"
          :disabled="current_id!=0"
        >
          <option v-for="exam in exams" :key="exam.value" :value="exam.value">
            {{ exam.text }}
          </option>
        </select>
      </div>
    </div>
    <input
      v-if="tablename=='g_elearning_modules' && current_id>0"
      type="hidden"
      v-model="control_exam_id"
    />
    <div
      v-if="tablename=='g_elearning_modules' && control_exam_id>0"
      class="col-12 float-start"
    >
      <div class="mb-3">
        <label class="form-label">Module number</label>
        <input class="form-control" v-model="control_module_number" /> 
      </div>  
      <div class="mb-3">
        <label class="form-label">Exam title</label>
        <input class="form-control" v-model="control_exam_title" /> 
      </div> 
      <div class="mb-3">
        <label class="form-label">Exam teacher</label>
        <select
          class="form-select"
          v-model="record['module_teacher_id']"
        >
          <option 
            v-for="opt in dbfields.filter(f => f.field_name == 'module_teacher_id')[0].lookup_options" 
            :key="opt.value" 
            :value="opt.value"
          >
            {{ opt.text }}
          </option>
        </select>
      </div>   
    </div>
    <template v-if="!control_exam_id || control_exam_id==0">
    <div
      v-for="dbfield in screenfields"
      v-bind:key="dbfield.id"
      :class="'col-'+dbfield.colspan+' float-start'"
    >
      <div
        v-if="dbfield.input_type != 'HIDDEN' && (tablename!='g_elearning_modules' || dbfield.field_name != 'exam_module_teacher_id')"
        class="mb-3"
      >
        <label v-if="dbfield.input_type!='CHECKBOX'&&dbfield.input_type!='GRID'&&dbfield.input_type!='NONE'" class="form-label">
          {{dbfield.input_caption}}
          <span
            v-if="dbfield.field_name=='consultant_id'"
            class="me-2"
            @click.prevent.stop="switchto(record[dbfield.field_name])"
            style="cursor: zoom-in"
          >
            <fa-icon name="key" />
          </span>
        </label>
        
        <!-- Checkbox Group -->
        <div v-if="dbfield.input_type=='CHECKBOXGROUP' && dbfield.lookup_options.length > 0">
          <div v-for="option in dbfield.lookup_options" :key="option.value" class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              :value="option.value"
              :id="`${dbfield.field_name}_${option.value}`"
              v-model="record[dbfield.field_name]"
              :disabled="dbfield.input_readonly=='1'"
            />
            <label class="form-check-label" :for="`${dbfield.field_name}_${option.value}`">
              {{ option.text }}
            </label>
          </div>
        </div>
        
        <!-- Date -->
        <datetime 
          v-if="dbfield.input_type=='DATE'"
          type="date"
          format="yyyy-LL-dd"
          v-model="record[dbfield.field_name]"
          :disabled="dbfield.input_readonly=='1'"
          :phrases="{ok: 'OK', cancel: 'Cancel'}"
          value-zone="Europe/Stockholm"
          zone="Europe/Stockholm"
        ></datetime>
        
        <!-- Text Input -->
        <input 
          v-if="dbfield.input_type=='TEXT'" 
          class="form-control"
          v-model="record[dbfield.field_name]" 
          :disabled="dbfield.input_readonly=='1'" 
        />
        
        <!-- Password -->
        <password-input 
          v-if="dbfield.input_type=='PASSWORD'" 
          type="password" 
          v-model="record[dbfield.field_name]" 
          :disabled="dbfield.input_readonly=='1'" 
        />
        
        <!-- Textarea -->
        <textarea 
          v-if="dbfield.input_type=='TEXTAREA'" 
          class="form-control"
          rows="3"  
          v-model="record[dbfield.field_name]" 
          :disabled="dbfield.input_readonly=='1'"
        ></textarea>
        
        <!-- HTML Editor -->
        <vue-editor
          v-if="dbfield.input_type=='HTML'" 
          v-model="record[dbfield.field_name]"
          :editor-toolbar="editortoolbar"
        />
        
        <!-- Checkbox -->
        <div v-if="dbfield.input_type=='CHECKBOX'" class="form-check">
          <input 
            class="form-check-input"
            type="checkbox"
            :id="dbfield.field_name"
            v-model="record[dbfield.field_name]"
            :true-value="1"
            :false-value="0"
          />
          <label class="form-check-label" :for="dbfield.field_name">
            {{dbfield.input_caption}}
          </label>
        </div>
        
        <!-- Select -->
        <div v-if="dbfield.input_type=='SELECT'">
          <select
            class="form-select"
            v-model="record[dbfield.field_name]"
            :disabled="dbfield.field_name==mainfield || dbfield.input_readonly == '1'"
            @change="load_subselect(dbfield)"
          >
            <option v-for="opt in dbfield.lookup_options" :key="opt.value" :value="opt.value">
              {{ opt.text }}
            </option>
          </select>
        </div>
        
        <!-- Sub Select -->
        <div v-if="dbfield.input_type=='SUBSELECT'">
          <select
            class="form-select"
            v-model="record[dbfield.field_name]"
            :disabled="dbfield.field_name==mainfield"
          >
            <option v-for="opt in dbfield.lookup_options" :key="opt.value" :value="opt.value">
              {{ opt.text }}
            </option>
          </select>
        </div>
        
        <!-- Radio Group -->
        <div v-if="dbfield.input_type=='RADIO'">
          <div v-for="option in dbfield.lookup_options" :key="option.value" class="form-check">
            <input
              class="form-check-input"
              type="radio"
              :name="dbfield.field_name"
              :id="`${dbfield.field_name}_${option.value}`"
              :value="option.value"
              v-model="record[dbfield.field_name]"
            />
            <label class="form-check-label" :for="`${dbfield.field_name}_${option.value}`">
              {{ option.text }}
            </label>
          </div>
        </div>
        
        <!-- Image Upload -->
        <div v-if="dbfield.input_type==='IMAGE'">
          <div class="col-12 float-start ps-0">
            <input
              type="file"
              class="form-control"
              @change="image_show"
              accept=".jpg, .png, .gif"
            />
          </div>
          <div v-show="image" class="col-12 float-end text-end align-top me-0 mt-2">
            <img class="me-2 align-top" :src="image" style="max-width: 200px;" />
            <button
              class="btn btn-danger"
              @click.prevent="image_clear()"
            >
              Clear
            </button>
          </div>
        </div>
        
        <!-- Grid/SubTable -->
        <div
          v-if="dbfield.input_type=='GRID' && current_id > 0 && nosubtables != 'true'"
          class="card"
        >
          <div class="card-header">
            <h5 class="card-title mb-0">{{dbfield.input_caption}}</h5>
          </div>
          <div class="card-body">
            <MaintenanceList
              :name="dbfield.field_name"
              :tablename="dbfield.field_name"
              :mainfield="dbfield.lookup_field"
              :mainvalue="current_id"
            />
          </div>
        </div>
      </div>
      <input
        type="hidden"
        v-if="dbfield.input_type=='HIDDEN' && (tablename!='g_elearning_modules' || dbfield.field_name != 'exam_module_teacher_id')"
        :value="record[dbfield.field_name]"
      />
    </div>          
    </template>
  </div>
</template>
<script>
/* eslint-disable no-console */
import axios from 'axios'
import VueEditor from '../CustomControls/VueEditor.vue'
import Datetime from '../CustomControls/Datetime.vue';
import { config } from '../../../config';
import PasswordInput from '../CustomControls/PasswordInput.vue';
const base_url = config.base_url;
const api_token = config.api_token;
const editortools = [
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  ['bold', 'italic', 'strike'],
  [
    { align: '' },
    { align: 'center' },
    { align: 'right' },
    { align: 'justify' }
  ],
  [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
  [{ color: [] }, { background: [] }],
  ['link'],
  //  ["link", "image", "video", "formula"],
  ['image'],
]

export default {
  name: 'MaintenanceDetail',
  props: [
    'tablename',
    'mainfield',
    'mainvalue',
    'standalone',
    'noedit',
    'ismodal',
    'istree',
    'nosubtables'
  ],
  components: {
    PasswordInput,
    Datetime,
    VueEditor,
    MaintenanceList: () => import('./MaintenanceList.vue'),
  },
  data: function() {
    return {
      editortoolbar: editortools,
      dbfields: [],
      imagefields: [],
      screenfields: [],
      current_id: this.standalone || 0,
      record: [],
      lookupoptions: [],
      savereturn: true,
      imagefile: null,
      image: null,
      saving: false,
      control_exam_id: null,
      control_exam_title: '',
      control_module_number: '',
      exams: [],
    }
  },
  watch: {
    '$route.path': function() {
      this.init();
    },
  },
  created() {
    this.exams_get();
    this.init();
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      console.log('init', this.exams)
      await this.$nextTick();
      this.fields_get()
      .then(() => {
        if (this.current_id != 0) { this.record_edit(this.current_id); return true }  
        for (var i=0;i<this.dbfields.length;i++) {
          const f = this.dbfields[i];
          this.record[f.field_name] = f.input_default;
          this.record[this.dbfields[i].lookup_options] = [];
          // Set default to user_id field if no input
          if (f.input_type == 'NONE') {
            if (f.field_name=='user_id') {
              this.record[f.field_name] = this.$store.state.user_id;
            }
          }
          if (f.input_type === 'FILE') {
            this.record[f.field_name] = null;
          }
          if (f.input_type == 'CHECKBOXGROUP') {
            this.record[f.field_name] = [];
          }
        }
        if (this.mainfield) {
          this.record[this.mainfield] = this.mainvalue;
        }
      })
    },
    fields_get() {
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      return new Promise((resolve) => {
      axios.get(
          base_url+"/fields/"+this.tablename,
          '', {
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json",
            }
          }
        )
        .then(resp => {
          // dbfields = all fields for the table from the DB
          var dbfields = resp.data;
          // console.log(dbfields);
          // Now, we need to find all fields that point to another field hmmm
          const g = dbfields.filter(
            a => a.input_type == 'SUBSELECT'
          );
          g.forEach( f => {
            for (var i=0;i<dbfields.length;i++) {
              if (dbfields[i].field_name == f.control_field) {
                dbfields[i]['subtable'] = f.lookup_table;
                dbfields[i]['subfield'] = f.subtable_filter_field;
              }
            } 
          });
          dbfields = dbfields.map( f => {
            return {
              ...f,
              colspan: 12,
            }
          });
          var start = -1;
          const screenfields = dbfields.filter( f => f.input_type !== 'NONE');
          for (var i=0;i<screenfields.length;i++) {
            if (screenfields[i].input_merge_next === "1" && start === -1) {
              start = i;
            }
            if (screenfields[i].input_merge_next == 0 && start != -1 && i != start) {
              const colspan = Math.round(12/((i+1)-start));
              for (var j=start;j<=i;j++) {
                screenfields[j].colspan = colspan;
              }
              start = -1;
            }
            screenfields[i].lookup_options = screenfields[i].lookup_options ? screenfields[i].lookup_options : [];
          }
          this.dbfields = dbfields;
          this.screenfields = screenfields;
          this.imagefields = dbfields.filter(f => f.input_type === 'IMAGE');   
        })
        .then(resp => {
          resolve(resp);
        })
      });
    },
    record_edit(id) {
      for (var i=0;i<this.dbfields.length;i++) {
        this.record[this.dbfields[i].field_name] = this.dbfields[i].input_default;
        this.record[this.dbfields[i].lookup_options] = [];
        this.load_subselect(this.dbfields[i]);
      }
      if (this.current_id != -1) {
        axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
        return new Promise((resolve) => {
          axios.get(
            base_url+"/"+this.tablename+"/"+id,
            '', {
              headers: {
                "Accept": "application/json",
                "Content-type": "application/json",
              }
            }
          )
          .then((resp) => {
            const fields = this.dbfields;
            let record = [];
            fields.forEach((f) => { 
              record[f.field_name] = resp.data[f.field_name];
              if (f.input_type === 'IMAGE') {
                if (resp.data[f.field_name]) {
                  const data = {
                    table_name: this.tablename,
                    field_name: f.field_name,
                    id: id
                  }
                  this.$store.dispatch('image_get', data)
                  .then((resp) => {
                    // console.log(typeof resp);
                    if (resp) {
                      this.image = URL.createObjectURL(resp);
                    }
                  });
                } else {
                  this.image = null;
                }
              }
              if (f.input_type === 'CHECKBOXGROUP') {
                record[f.field_name] = record[f.field_name].split(',');
              }
              this.load_subselect(f);
            });
            if (this.mainfield) {
              record[this.mainfield] = this.mainvalue;
            }                    
            this.current_id = resp.data.id;
            if (this.tablename == 'g_elearning_modules') {
              this.control_exam_id = resp.data.exam_id;
              this.control_exam_title = resp.data.exam_title;
              this.control_module_number = resp.data.module_number;
            }
            this.record = record;
            console.log('record_edit', this.record);                     
            resolve(resp);
          })
        })
      }
    },
    record_save() {
      this.saving = true;
      this.saveerror = '';
      var saverec;
      if (this.tablename == 'g_elearning_modules' && this.control_exam_id > 0) {
        saverec = {
          id: this.current_id,
          course_id: this.mainvalue,
          exam_id: this.control_exam_id,
          exam_title: this.control_exam_title,
          module_number: this.control_module_number,
          module_name: this.control_exam_title,
          module_teacher_id: this.record.module_teacher_id,
        }
      } else {
        saverec = {
          id: this.current_id,
        }
        for (var i=0;i<this.dbfields.length;i++) {
          if (this.dbfields[i].input_type == 'DATE') {
            saverec[this.dbfields[i].field_name] = this.format_date(this.record[this.dbfields[i].field_name]);
          } else {
            saverec[this.dbfields[i].field_name] = this.record[this.dbfields[i].field_name];
          }
          if (this.dbfields[i].input_type == 'CHECKBOX') {
            if (this.record[this.dbfields[i].field_name] == '' ) {
              saverec[this.dbfields[i].field_name] = '0';
            }
          }
        }
      }
      if (this.current_id > 0) {
        this.record_put(saverec)
        .then((result) => {
          this.saving = false;
          if (result.data.error) {
            this.saveerror = result.data.error;
          } else {
            for (let i=0;i<this.imagefields.length; i++) {
              this.image_save(this.imagefields[i].field_name);
            }
            this.$emit('modalSave', this.current_id);          
            this.current_id = 0; 
            return true;
          }
        })
      } else {
        this.record_post(saverec)
        .then((result) => {
          this.saving = false;
          if (result.data.error) {
              this.saveerror = result.data.error;
          } else {
            this.current_id = result.data.id;
            for (let i=0;i<this.imagefields.length; i++) {
              this.image_save(this.imagefields[i].field_name);
            } 
            if (!this.savereturn) {                    
              this.written='created';
            } else {
              this.$emit('modalSave', this.current_id);
              this.current_id = 0;
              return true;
            }
          }
        })
      }
    },
    image_save(field_name) {
      this.saving = true;
      const fd = new FormData();
      const image = this.imagefile;
      fd.append('table_name', this.tablename);
      fd.append('id',this.current_id);
      fd.append('field_name',field_name);
      fd.append('image', image);
      this.$store.dispatch('image_save', fd)
      .then(() => { this.saving = false; })
    },
    image_clear() {
      this.image = null;
      this.imagefile = null;
    },
    image_show(e) {
      const file = e.target.files[0];
      this.imagefile = file;
      this.image = URL.createObjectURL(file);
    },
    record_put(record) {
      this.saving = true;
        axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
        return new Promise((resolve) => {
            axios.put(
                base_url+"/"+this.tablename+"/"+this.current_id,
                JSON.stringify(record), {
                    headers: {
                        "Accept": "application/json",
                        "Content-type": "application/json",
                    }
                }
            )
            .then((resp) => {
              this.saving = false;
                resolve(resp);
            })                
        });
    },
    record_post(record) {
      this.saving = true;
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      return new Promise((resolve) => {
          axios.post(
              base_url+"/"+this.tablename,
              JSON.stringify(record), {
                  headers: {
                      "Accept": "application/json",
                      "Content-type": "application/json",
                  }
              }
          )
          .then((resp) => {
            this.saving = false;
              resolve(resp);
          })
      });
    },
    record_cancel() {
      this.$emit('modalCancel', this.current_id);
      return true;
    },
    record_savereturn() {
      this.savereturn = true;
      this.record_save();
    },
    load_subselects() {
      for (var i=0;i<this.dbfields.length;i++) {
        this.load_subselect(this.dbfields[i]);
      }
    },
    load_subselect(field) {
      if (field.subfield) {
        const table_name = field.subtable;
        const filter = {
          [field.subfield]: {
              operator: '=',
              value: this.record[field.field_name],                 
          }
        };
        const lu = this.dbfields.filter (a => {
          return a.lookup_table == table_name;
        });
        const lookup_field = lu[0].lookup_field;
        const lookup_display = lu[0].lookup_display;
        const lookup_sort = lu[0].lookup_sort;
        axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
        return new Promise((resolve,reject) => {
          axios.get(
            base_url+'/'+table_name+'?'
            +'filter='+JSON.stringify(filter)
            +'&orderby='+lookup_sort
          )
          .then(resp => {
            const records = resp.data.result;
            const v = records.map ((a) => {
              return {
                value: a[lookup_field],
                text: a[lookup_field]+' - '+a[lookup_display],
              }
            });
            for (var i=0;i<this.dbfields.length;i++) {
              if (this.dbfields[i].control_field == field.field_name) {
                this.dbfields[i].lookup_options = v;
              }
            }
            resolve(resp);
          })
          .catch(err => {
            reject(err)
          })
        })                
      }
    },
    async exams_get() {
      this.exams = [];
      if (this.tablename != 'g_elearning_modules') { return; }
      this.exams.push({value: 0, text: 'This is not an exam'});
      await this.$store.dispatch('records_readall', { table_name: 'g_elearning_exams', orderBy: 'exam_name'})
      .then((resp) => {
        const exams = resp.data.result;
        for (var i=0;i<exams.length;i++) {
          this.exams.push({value: exams[i].id, text: exams[i].exam_name});
        }
      });
    },
    //=================
    // HELPER FUNCTIONS
    //=================
    format_date(date) {
      var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
      if (isNaN(year)) { return ''; }
      if (Number.isNaN(month)) { return ''; }
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    },
    format_time(date) {
      if (date.length == 5) {
        return date;
      }
      var d = new Date(date);
      var h = d.getHours();
      var m = d.getMinutes();
      var hour = (h>9?'':'0')+h;
      var minute = (m>9?'':'0')+m;
      var thistime = hour+':'+minute;
      return thistime;
    },        
  }, 
}
</script>
<style>
</style>
